import { createVNode } from "vue";

var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(_, _ref) {
  var _slots$default;

  var attrs = _ref.attrs,
      slots = _ref.slots;
  return createVNode("div", {
    "class": attrs.class,
    "onClick": function onClick(e) {
      return e.stopPropagation();
    }
  }, [(_slots$default = slots.default) === null || _slots$default === void 0 ? void 0 : _slots$default.call(slots)]);
};

FilterDropdownMenuWrapper.inheritAttrs = false;
export default FilterDropdownMenuWrapper;